import React from 'react';
import svg from './img/baseline-keyboard_arrow_down-24px.svg';
import Icon from './Icon';

export default function KeyboardArrowDownIcon (prop) {
  return (<Icon icon={svg} {...prop} />);
}


// WEBPACK FOOTER //
// ./src/components/common/Icon/KeyboardArrowDownIcon.jsx